module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch3_20210921081149_T.fee71168.jpg";